<template>
  <div
    id="app"
    :class="[routeClass, { fadeOut: refreshing }]"
    :style="appStyle"
  >
    <router-view />
    <loading-screen-component />

    <footer-component v-if="isFooterVisible" :class="footerClass" />
    <!-- <popup-component v-if="isPopuperVisible" /> -->
  </div>
</template>

<script>
import FooterComponent from "./components/FooterComponent.vue";
import LoadingScreenComponent from "./components/LoadingScreenComponent.vue";
// import PopupComponent from "./components/PopupComponent.vue";

export default {
  components: { FooterComponent, LoadingScreenComponent },
  name: "App",
  data() {
    return {
      refreshing: false,
      isFooterVisible: true,
      isPopuperVisible: true,
      // loading: false,
    };
  },

  computed: {
    routeClass() {
      return this.$route.name;
    },
    isSearchOrMitra() {
      return ["Search", "MitraDetail"].includes(this.$route.name);
    },
    appStyle() {
      return {
        backgroundColor: this.isSearchOrMitra ? "#fff" : "#fff",
      };
    },
    footerClass() {
      return this.isSearchOrMitra ? "padding-search" : "";
    },
  },
  mounted() {
    window.addEventListener("beforeunload", () => {
      this.refreshing = true;
    });
  },
  created() {
    this.hideComponentsIfNeeded();
  },
  methods: {
    hideComponentsIfNeeded() {
      const currentRouteName = this.$route.name;
      if (currentRouteName === "NotFound" || currentRouteName === "Invoice") {
        this.isFooterVisible = false;
        this.isPopuperVisible = false;
      }
    },
  },
};
</script>

<style>
.fadeOut {
  animation: 0.5s ease;
}
.padding-search .footer {
  padding-bottom: 20px;
}
</style>
<head>
  <title>{{ $metaInfo.title }}</title>
</head>
